module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#listicle",
      toString: function () {
        return this.url;
      }
    }